export const categoryTranslateKey = (_category: string) => {
  const category = _category
    .toLowerCase()
    .normalize("NFD") // Normalize accents
    .replace(/[\u0300-\u036f]/g, "") // Remove accents
    .replace(/['\s]+/g, "-");

  return categoriesMap[category] ? `categories.${categoriesMap[category]}` : category;
};

export const subCategoryTranslateKey = (_subCategory: string) => {
  if (!_subCategory || !_subCategory.includes(">")) {
    return _subCategory ?? "";
  }
  // Remove part before the '>' and trim spaces
  let subCategory = _subCategory.split(">")[1].trim();

  // Convert to lowercase and replace spaces, single quotes, or special characters with hyphens
  subCategory = subCategory
    .toLowerCase()
    .normalize("NFD") // Normalize accents
    .replace(/[\u0300-\u036f]/g, "") // Remove accents
    .replace(/['\s]+/g, "-");

  return subCategoriesMap[subCategory]
    ? `subCategories.${subCategoriesMap[subCategory]}`
    : subCategory;
};

export const countryTranslateKey = (_country: string) => {
  const country = _country
    ?.toLowerCase()
    .normalize("NFD") // Normalize accents
    .replace(/[\u0300-\u036f]/g, "") // Remove accents
    .replace(/['\s]+/g, "-");

  return `countries.${country}`;
};

export const stateTranslateKey = (_state: string) => {
  const state = _state
    ?.toLowerCase()
    .normalize("NFD") // Normalize accents
    .replace(/[\u0300-\u036f]/g, "") // Remove accents
    .replace(/['\s]+/g, "-");

  return `states.${state}`;
};
export const getCategoryStats = (_category: string) => {
  const category = _category
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/['\s]+/g, "-");

  switch (category) {
    case "animalerie":
      return { fb: 100, instagram: 10 };
    case "fete-et-mariage":
      return { fb: 400, instagram: 400 };
    case "gastronomie":
      return { fb: 2350, instagram: 1600 };
    case "habillement":
      return { fb: 1700, instagram: 1000 };
    case "loisir":
      return { fb: 550, instagram: 350 };
    case "maison-et-jardin":
      return { fb: 1050, instagram: 500 };
    case "mere-et-enfant":
      return { fb: 100, instagram: 50 };
    case "sante-et-beaute":
      return { fb: 250, instagram: 300 };
    default:
      return { fb: 0, instagram: 0 };
  }
};

const subCategoriesMap: Record<string, string> = {
  gateaux: "cakes",
  restaurants: "restaurants",
  patessieres: "pastryShops",
  divers: "various",
  "sucre-personnalise": "customSweets",
  "salle-de-bain": "bathroom",
  "art-mural": "wallArt",
  jardin: "garden",
  electromenager: "homeAppliances",
  decoration: "decoration",
  cuisine: "kitchen",
  rideaux: "curtains",
  meuble: "furniture",
  "outils-de-bricolage": "diyTools",
  photographe: "photographers",
  "deco-fete": "partyDecor",
  "salle-de-fete": "partyHalls",
  femme: "womenClothing",
  homme: "menClothing",
  enfant: "childrenClothing",
  "montres-et-bijoux": "watchesAndJewelry",
  chaussures: "shoes",
  "sac-et-accessoires": "bagsAndAccessories",
  "accessoires-&-jouets": "accessoriesAndToys",
  aliments: "food",
  "vente-&-achat": "animalTrade",
  zhez: "zhez",
  "maquillage-&-parfum": "makeupAndPerfume",
  parfum: "perfume",
  "jouet-enfant": "childrenToys",
  jouets: "childrenToys",
  coiffure: "beautySalons",
  "robe-de-mariage": "weddingDresses",
  tapis: "carpets",
  "periculture-bebe": "babyCare",
  sale: "saltyFood",
  traditionel: "traditional",
  parapharmacie: "pharmacyAndBodyCare",
  "maisons-d-hotes": "guestHouses",
  services: "services",
  "voyages-tips-and-tricks": "travelTipsAndTricks",
  "agence-de-voyages": "travelAgencies",
  "parc-d-enfants": "childrenParks",
  soins: "bodyCareProducts",
};
export const categoriesMap: Record<string, string> = {
  "sante-et-beaute": "healthAndBeauty",
  "mere-et-enfant": "motherAndChild",
  "maison-et-jardin": "homeAndGarden",
  gastronomie: "gastronomy",
  immobilier: "realEstate",
  habillement: "clothing",
  loisir: "leisure",
  "fete-et-mariage": "celebrationsAndWeddings",
  animalerie: "petSupplies",
};
